import React from 'react';
import { makeStyles } from '@mui/styles';
import { Grid2 } from '@mui/material';

import { Page } from 'components';
import {
	Header,
	Overview,
	FinancialStats,
	EarningsSegmentation,
	TopReferrals,
	MostProfitableProducts,
	CustomerActivity,
	LatestOrders,
} from './components';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		'& > *': {
			height: '100%',
		},
	},
}));

const DashboardAnalytics = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="Analytics Dashboard">
			<Header />
			<Grid2 className={classes.container} container spacing={3}>
				<Grid2 item size={12}>
					<Overview />
				</Grid2>
				<Grid2 item size={8}>
					<FinancialStats />
				</Grid2>
				<Grid2 item size={4}>
					<EarningsSegmentation />
				</Grid2>
				<Grid2 item size={8}>
					<LatestOrders />
				</Grid2>
				<Grid2 item size={4}>
					<CustomerActivity />
				</Grid2>
				<Grid2 item size={8}>
					<MostProfitableProducts />
				</Grid2>
				<Grid2 item size={4}>
					<TopReferrals />
				</Grid2>
			</Grid2>
		</Page>
	);
};

export default DashboardAnalytics;
